import { render, staticRenderFns } from "./VatDeductIndex.vue?vue&type=template&id=646c0882&scoped=true&"
import script from "./VatDeductIndex.vue?vue&type=script&lang=js&"
export * from "./VatDeductIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c0882",
  null
  
)

export default component.exports